import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { topCorporationSchema, topPageMeta } from 'components/common/schema'
import Template from 'components/top/Top'

const Home: React.FunctionComponent = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...topPageMeta} />
      <JsonLd data={topCorporationSchema} />
      <Template />
    </>
  )
}

export default Home
